import * as React from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Card, CardContent, CardMedia, Typography } from '@mui/material';

// Import the image you want to use
import Contact_IMG from '../../../assets/Landing/sl.webp';
import IMG1 from '../../../assets/Landing/b1.webp';
import IMG2 from '../../../assets/Landing/b2.webp';
import IMG3 from '../../../assets/Landing/b3.webp';
import IMG4 from '../../../assets/Landing/b4.webp';
import IMG5 from '../../../assets/Landing/b5.webp';
import IMG6 from '../../../assets/Landing/b6.webp';

const LatestNewsCard = styled(Card)(({ theme }) => ({
  maxWidth: 345,
  margin: '16px', // Spacing between cards
  backgroundColor: '#fff',
  borderRadius: '8px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
}));

export default function LatestNewsSection() {
  const newsArticles = [
    {
      title: 'What Are The Changes In Canada For Tax Season 2023?',
      description: 'In 2023, the federal government adjusted the federal income tax brackets by 4.7% to account for inflation and therefore increased the thresholds of each federal income tax bracket. That means that you may pay a lower rate on more of your income because wages did not go up as much as inflation.',
      image: IMG1,
    },
    {
      title: 'Understanding the New Tax Regulations in Canada',
      description: 'This article covers the new tax regulations introduced in 2023, including changes in deductions and credits.',
      image: IMG2,
    },
    {
      title: 'Tax Planning Strategies for Small Businesses',
      description: 'Explore effective tax planning strategies that small businesses can implement to save on taxes.',
      image: IMG3,
    },
    {
      title: 'Digital Marketing Trends Every Business Should Know in 2024',
      description: 'Offer insights into the latest digital marketing trends, such as personalized advertising and automation, and how KALEIDO can help businesses stay ahead of the curve.',
      image: IMG4,
    },
    {
      title: 'Navigating International Tax Regulations: A Global Perspective',
      description: 'Provide tips on how businesses can handle complex tax regulations when operating in multiple countries, featuring KALEIDO’s expertise in international tax solutions.',
      image: IMG5,
    },
    {
      title: 'The Benefits of Cloud Accounting for Growing Businesses',
      description: 'Discuss the advantages of cloud accounting systems like Xero and QuickBooks, and how KALEIDO helps clients implement and manage cloud-based bookkeeping solutions for scalability.',
      image: IMG6,
    },
  ];

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ minHeight: '100vh' }}
    >
      {/* First Section */}
      <Box sx={{ width: '100%', position: 'relative', marginTop: '72px' }}>
        <Grid item xs={12}>
          <Grid 
            container 
            direction={{ xs: 'column-reverse', md: 'row' }} 
            justifyContent="center"
            alignItems="center"
          >
            {/* Image Section */}
            <Grid 
              item 
              xs={12} 
              md={6}
              sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center',
                mb: { xs: 4, md: 0 } // Add margin bottom on small screens
              }}
            >
              <CardMedia
                component="img"
                image={Contact_IMG}
                alt="Legal Services"
                style={{ height: '430px', width: '66%' }}
              />
            </Grid>
            {/* Text Section */}
            <Grid item xs={12} md={6}>
              <CardContent sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Typography 
                  variant="h3" 
                  component="div" 
                  gutterBottom  
                  color="#0067ff"
                  fontWeight={700}
                  sx={{ textAlign: { xs: 'center', md: 'left' }, paddingX: { xs: 2, md: 0 } }}
                >
                  What Are The Changes In SRI LANKA For Tax Season 2023?
                </Typography>
                <Typography variant="subtitle1" color="#252525" sx={{ mt: 2 }}>
                  In 2023, the federal government adjusted the federal income tax brackets by 4.7% to account for inflation and therefore increased the thresholds of each federal income tax bracket. That means that you may pay a lower rate on more of your income because wages did not go up as much as inflation.
                </Typography>
              </CardContent>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      {/* Latest News Section */}
      <Box sx={{ width: '100%', marginTop: '72px' }}>
        <Typography variant="h3" textAlign="center" gutterBottom color="#0067ff" fontWeight={700}>
          Latest News
        </Typography>
        <Grid container justifyContent="center">
          {newsArticles.map((article, index) => (
            <Grid item xs={12} sm={6} md={4} key={index} display="flex" justifyContent="center">
              <LatestNewsCard>
                <CardMedia
                  component="img"
                  height="200"
                  image={article.image}
                  alt="Latest News"
                />
                <CardContent>
                  <Typography variant="h6" fontWeight={700} gutterBottom>
                    {article.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {article.description}
                  </Typography>
                </CardContent>
              </LatestNewsCard>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Grid>
  );
}
